import styles from '../account.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { Button, Checkbox, Input, PageContainer, Select } from '@touche-lts/panel-ui/dist'
import { IconAddress, IconCheck, IconEdit, IconTrash } from 'assets/icons'
import { useEffect } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { AddressesDTO } from 'models'
import _ from 'lodash';
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const AccountAddressComponent = (props) => { 

  const {
    style
  } = props

  const {
    accountStore: {
      getUserAddressesById,
      userAddressesInfo,
      addressShippingBillingCountryOptions,
      getGeoShippingCountries,
      billingShippingInfo,
      setBillingShippingNamePrimary,
      setBilling,
      setShipping,
      addUserAddress,
      addEditBoxState,
      setAddEditBox,
      discardChanges,
      editUserAddress,
      updateUserAddress,
      makePrimary,
      deleteAdress,
      setSameAsBilling,
      sameAsBillingCheck
    },
  } = useRootStore(),

  // [isAddressCheckboxChecked, setAddressCheckbox] = useState<boolean>(false),

  userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id,

  handleAttributeCheckbox = (address: AddressesDTO): void => {
    makePrimary(address)
  },

  handleAddUserAddress = (): void => {
    if(billingShippingInfo['id'] != null) {
      updateUserAddress(userDetailsId)
    } else {
      addUserAddress(userDetailsId)
    }
  },

  handleEqualShippingBilling = (address: AddressesDTO): boolean => {
    const addressCheck = JSON.parse(JSON.stringify(address))
    delete addressCheck?.billingAddress?.id
    delete addressCheck?.shippingAddress?.id
    return _.isEqual(addressCheck.billingAddress, addressCheck.shippingAddress)
  }

  useEffect(()=> {
    getGeoShippingCountries()
    if(userDetailsId) {
      getUserAddressesById(userDetailsId)
    }
  }, [getGeoShippingCountries, getUserAddressesById, userDetailsId])

  const {isResponsive} = useGetIsResponsiveScreen(("(max-width:991px)"))

  return (
    <PageContainer className={cl(styles.scrollable, 'container')} style={{marginTop: 80, ...style}}>
      <div className="d-flex">
        <div className={styles.addressHeader}>
          <IconAddress /> 
          <span>Addresses</span>
        </div>
        <div className={styles.addNewAddress} onClick={() => setAddEditBox(true)}>
          <span>+</span>
          <p>Add new addresses</p>
        </div>
      </div>
      {addEditBoxState && (
        <div className={styles.addNewAddressBox}>
          <Input
            colorPreset='dark'
            placeholder='Add shipping name'
            className={styles.input}
            value={billingShippingInfo?.name}
            onChange={name => setBillingShippingNamePrimary({name})}
          />
          <div className="row">
            <div className="col-lg-6">
              <p className={styles.addNewAddressHeader}>Shipping address</p>
              <div className="row">
                <div className="col-lg-6">
                {!!addressShippingBillingCountryOptions.length && (
                    <div className={cl(styles.selectCountryContainer, 'mb-4')}>
                        <select 
                          value={billingShippingInfo?.shippingAddress?.country || ""}
                          onChange={country =>
                          setShipping({ country: (country as any).target.value })}
>
  <option value="" disabled>Select Country</option>
  {addressShippingBillingCountryOptions.map(opt => (
                                  <option 
                                  key={opt.value}
                                  value={opt.value}
                                  style={{background:'#333333'}}
                                  >{opt.label}</option>
                                  ))}
                        </select>
                    </div>
                )}
                  <Input
                    colorPreset='dark'
                    placeholder='Zip code'
                    value={billingShippingInfo?.shippingAddress?.zipcode}
                    onChange={zipcode => setShipping({zipcode})}
                  />
                </div>
                <div className="col-lg-6">
                  <Input
                    colorPreset='dark'
                    placeholder='City'
                    className={`mb-4 ${isResponsive && "my-4"}`}
                    value={billingShippingInfo?.shippingAddress?.city}
                    onChange={city => setShipping({city})}
                  /> 
                  <Input
                    colorPreset='dark'
                    placeholder='street'
                    className={styles.input}
                    value={billingShippingInfo?.shippingAddress?.address}
                    onChange={address => setShipping({address})}
                  />                
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <p className={styles.addNewAddressHeader}>Billing address</p>
              <div className={cl('row', sameAsBillingCheck ? styles.sameAsBilling : '')}>
                <div className="col-lg-6">
                  {!!addressShippingBillingCountryOptions.length && (
                    <div className={cl(styles.selectCountryContainer, 'mb-4')}>
                      <select 
                        value={billingShippingInfo?.billingAddress?.country || ""}
                        onChange={country =>
                        setBilling({ country: (country as any).target.value})}
                      >
                        <option value="" disabled>Select Country</option>
                        {addressShippingBillingCountryOptions.map(opt => (
                                <option 
                                key={opt.value}
                                value={opt.value}
                                style={{background:'#333333'}}
                                >{opt.label}</option>
                                ))}
                      </select>
                    </div>)}
                  <Input
                    colorPreset='dark'
                    placeholder='Zip code'
                    className={styles.input}
                    value={billingShippingInfo?.billingAddress?.zipcode}
                    onChange={zipcode => setBilling({zipcode})}
                  />
                </div>
                <div className="col-lg-6">
                  <Input
                    colorPreset='dark'
                    placeholder='City'
                    className={`mb-4 ${isResponsive && "my-4"}`}
                    value={billingShippingInfo?.billingAddress?.city}
                    onChange={city=> setBilling({city})}
                  /> 
                  <Input
                    colorPreset='dark'
                    placeholder='Street'
                    className={styles.input}
                    value={billingShippingInfo?.billingAddress?.address}
                    onChange={address=> setBilling({address})}
                  />
                </div>
              </div>
              <div className={styles.sameAsBillingAddress}>
                  <Checkbox style={{marginRight: 10}} isChecked={sameAsBillingCheck} onClick={() => setSameAsBilling(!sameAsBillingCheck)}/>
                  <p>Same as shipping address</p>
              </div>
              <div className={styles.addressButtons}>
                  <Button
                      preset='secondary'
                      colorPreset='dark'
                      style={{marginRight: 20}}
                      onClick={() => discardChanges()}
                  >
                      Discard
                  </Button>
                  <Button preset='primary' onClick={() => handleAddUserAddress()}>
                      Save
                  </Button>
              </div>
            </div>
          </div>
        </div>        
      )}
      <div className="m-4">
        <p className={styles.shippingAddressesHeaders}>Primary shipping addresses</p>
        <div className="d-flex flex-wrap">
            {userAddressesInfo && userAddressesInfo.map((address: AddressesDTO) => {
              return (
                <>
                {address?.primary && (
                  <div className={styles.primaryShippingBox}>
                    <div className={styles.shippingBox}>
                      <div className={styles.shippingInfo}>
                        <p>{address?.name}</p>
                        <h4>Shipping address</h4>
                        <span>{address?.shippingAddress?.country}</span>
                        <span>{address?.shippingAddress?.city}</span>
                        <span>{address?.shippingAddress?.address}</span>
                        <span>{address?.shippingAddress?.zipcode}</span>
                      </div>
                      {!handleEqualShippingBilling(address) && (
                      <div className={styles.shippingInfo}>
                        <h4 style={{paddingTop: 29}}>Billing address</h4>
                        <span>{address?.billingAddress?.country}</span>
                        <span>{address?.billingAddress?.city}</span>
                        <span>{address?.billingAddress?.address}</span>
                        <span>{address?.billingAddress?.zipcode}</span>
                      </div>
                      )}
                      <div className="d-flex flex-column">
                          <div className={styles.shippingBoxCheckboxes}>
                            <IconCheck />
                            <span>Primary</span>
                          </div>
                          {handleEqualShippingBilling(address) && (
                            <div className={styles.shippingBoxCheckboxes}>
                              <IconCheck />
                              <span>Same as billing address</span>
                            </div>
                          )}
                          <div className={styles.editDeleteIcons}>deleteAdress
                              <IconEdit fill={styles.white} onClick={() => editUserAddress(address)}/>
                              <IconTrash fill={styles.white} onClick={() => deleteAdress(address?.id)} />
                          </div>
                      </div>
                    </div>
                  </div>
                )}
                </>
              )
            })}
        </div>
      </div>
      <div className="m-4">
        <p className={styles.shippingAddressesHeaders}>Other shipping addresses</p>
        <div className="d-flex flex-wrap">
            {userAddressesInfo && userAddressesInfo.map((address: AddressesDTO) => {
              return (
                <>
                {!address?.primary && (
                  <div className={styles.otherShippingsBox}>
                    <div className={styles.otherPrimaryLine}>
                        <p>{address?.name}</p>
                        <div className="d-flex">
                            <Checkbox style={{marginRight: 10}} isChecked={address?.primary} onClick={() => handleAttributeCheckbox(address)} />
                            <p className="pt-1">Make primary</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className={styles.shippingInfo}>
                            <h4>Shipping address</h4>
                            <span>{address?.shippingAddress?.country}</span>
                            <span>{address?.shippingAddress?.city}</span>
                            <span>{address?.shippingAddress?.address}</span>
                            <span>{address?.shippingAddress?.zipcode}</span>
                        </div>
                        <div className={styles.shippingInfo}>
                            <h4>Billing address</h4>
                            <span>{address?.billingAddress?.country}</span>
                            <span>{address?.billingAddress?.city}</span>
                            <span>{address?.billingAddress?.address}</span>
                            <span>{address?.billingAddress?.zipcode}</span>
                        </div>
                        <div className={styles.editDeleteIcons}>
                            <IconEdit fill={styles.white} onClick={() => editUserAddress(address)} />
                            <IconTrash fill={styles.white} onClick={() => deleteAdress(address?.id)} />
                        </div>
                    </div>
                  </div>
                )}
                </>
              )
            })}
        </div>
      </div>
    </PageContainer>
  )
},

AccountAddress = observer(AccountAddressComponent)
export { AccountAddress }
